export default "__VITE_ASSET__b6004977__"